import {
  Box,
  Button,
  IconButton,
  CircularProgress,
  Container,
  Tab,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import Divider from "@mui/material/Divider";

import AddChatDrawer from "./components/AddChatDrawer";
import {
  _addUserInChatList,
  _getAllChats,
  _getChatMessages,
  _getGroupChatList,
  _seenMessages,
} from "src/DAL";
import { useSnackbar } from "notistack";
import ChatHeader from "./components/ChatHeader";
import ChatListSidebar from "./components/ChatListSidebar";
import MessageContainer from "./components/MessageContainer";
import { useAppContext } from "src/hooks";
import { chat } from "src/assets";
import ChatListDrawer from "./components/ChatListDrawer";
import { Page } from "src/components";
import { capitalize, debounce } from "lodash";
import { TabContext, TabList } from "@mui/lab";
import StyledChatSearch from "src/components/search/StyledChatSearch";
import { del_from_local_storage } from "src/utils";
import ShowSingleChat from "./components/ShowSingleChat";
import { del_from_sessionStorage } from "src/utils/sessionStorage";
import { capitalizeAllWords } from "src/utils/stringFunctions";

function Chats() {
  const {
    currentChat,
    setCurrentChat,
    chatList,
    setChatList,
    chatCount,
    setChatCount,
    chatType,
    setChatType,
    socketEmit,
    getModifiedChatItem,
    chatListDrawerOpen,
    setChatListDrawerOpen,
    setBadge,
    setIsOpenChatDialog,
    isOpenChatDialog,
    dispatch_get_user_profile,
    chatListLoading,
    setChatListLoading,
  } = useAppContext();
  const { enqueueSnackbar } = useSnackbar();
  // shamroz - include id in path /chat/{id}
  const navigate = useNavigate();
  const { id } = useParams();
  // -------------------------------------

  const [isAddChatDrawerOpen, setIsAddChatDrawerOpen] = useState(false);
  ///////////////////Chats///////////////////////////////////////////////

  const [chatListPage, setChatListPage] = useState(0);
  const [addChatLoading, setAddChatLoading] = useState(false);
  const [firstTimeCalled, setFirstTimeCalled] = useState(true);
  const [fullChatList, setFullChatList] = useState(chatList);
  const modifiedChatList = (list) => {
    const modified = list.map((chat) => {
      return { ...getModifiedChatItem(chat) };
    });
    return [...modified];
  };
  const getChatsList = async (type, isShowLoader = true) => {
    if (isShowLoader) {
      setChatListLoading(true);
    }
    try {
      if (type == "all") {
        const result = await _getAllChats(0, 15);
        if (result.code == 200) {
          let tempChatList = modifiedChatList(result.chat_list.chat_list);
          tempChatList.sort((a, b) => {
            const dateA = new Date(a.last_message?.createdAt || 0);
            const dateB = new Date(b.last_message?.createdAt || 0);
            return dateB - dateA;
          });
          if (currentChat) {
            let temp = tempChatList.findIndex(
              (chat) => chat._id == currentChat._id
            );
            if (temp == -1) {
              tempChatList.unshift(currentChat);
            } else {
              setCurrentChat(tempChatList[temp]);
            }
          }
          console.log("chatlist updated no: 11");
          setFullChatList(tempChatList);
          setChatList(tempChatList);
          setChatCount(result.chat_list.chat_list_count);
          setChatListPage((prev) => prev + 1);
        } else {
          enqueueSnackbar(result.message, { variant: "error" });
        }
      } else if (type == "groups") {
        const result = await _getGroupChatList(0, 15);
        setChatCount(result.group_list.group_chat_list_count);
        let tempChatList = modifiedChatList(result.group_list.group_chat_list);
        if (currentChat && currentChat.type == "1") {
          let temp = tempChatList.findIndex(
            (chat) => chat._id == currentChat._id
          );
          if (temp == -1) {
            tempChatList.unshift(currentChat);
          } else {
            setCurrentChat(tempChatList[temp]);
          }
        }
        console.log("chatlist updated no: 12");
        setFullChatList(tempChatList);
        setChatList(tempChatList);
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      console.log(error, "error catched");
    } finally {
      setChatListLoading(false);
    }
  };
  const handleAddNewChat = async (user) => {
    console.log(user, "adding user");
    setAddChatLoading(true);
    try {
      let temp = chatList.findIndex(
        (chat) => chat.type == "0" && chat.user[0].user_id == user.user_id
      );
      if (temp !== -1) {
        if (currentChat?._id !== chatList[temp]._id) {
          // shamroz - include id in path /chat/{id}
          navigate(`/chats/${chatList[temp]._id}`);
          // -------------------------------------
          setCurrentChat(chatList[temp]);
          setMessageList([]);
          setMessageListPageNo(0);
          getMessageList(chatList[temp]);
        }
        setChatListDrawerOpen(false);
        setIsAddChatDrawerOpen(false);
        return;
      }

      const req_data = {
        team: [
          {
            user_id: user.user_id,
            first_name: user.first_name,
            last_name: user.last_name,
            email: user.email,
            image: user.image,
            status: user.status,
            role: user.role,
            user_status: user.user_status,
          },
          {
            user_id: dispatch_get_user_profile().user_id,
            first_name: dispatch_get_user_profile().first_name,
            last_name: dispatch_get_user_profile().last_name,
            email: dispatch_get_user_profile().email,
            image: dispatch_get_user_profile().image,
            status: dispatch_get_user_profile().status,
            role: "team",
            user_status: dispatch_get_user_profile().user_status,
          },
        ],
      };
      console.log(req_data, "sending data in API when Creating new Chat");
      const result = await _addUserInChatList(req_data);
      if (result.code == 200) {
        console.log(
          result.chat,
          "Receiving data from API when Creating new Chat"
        );
        // if (chatType == "all") {
        //   setChatList((prev) => {
        //     return [getModifiedChatItem(result.chat), ...prev];
        //   });
        //   setChatCount((prev) => prev + 1);
        // }
        setCurrentChat(getModifiedChatItem(result.chat));
        // shamroz - include id in path /chat/{id}
        navigate(`/chats/${result.chat._id}`);
        // -------------------------------------
        setIsAddChatDrawerOpen(false);
        enqueueSnackbar("Chat added successfully", { variant: "success" });
        setMessageList([]);
        setMessageListPageNo(0);
        setChatListDrawerOpen(false);
        console.log(
          "Passing Data to Socket while Creating Chat: ",
          result.chat
        );
        socketEmit("addNewChat", result.chat);
      } else if (result.code == 400 && result.chat) {
        if (chatType == "all") {
          console.log("chatlist updated no: 13");
          setChatList((prev) => {
            return [getModifiedChatItem(result.chat), ...prev];
          });
          setFullChatList((prev) => {
            return [getModifiedChatItem(result.chat), ...prev];
          });
        }
        setCurrentChat(getModifiedChatItem(result.chat));
        // shamroz - include id in path /chat/{id}
        navigate(`/chats/${result.chat._id}`);
        // -------------------------------------
        setIsAddChatDrawerOpen(false);
        setMessageList([]);
        setMessageListPageNo(0);
        setChatListDrawerOpen(false);
        getMessageList(getModifiedChatItem(result.chat));
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      console.log(error, "error catched while adding chat");
    } finally {
      setAddChatLoading(false);
    }
  };
  // useEffect(() => {
  //   if (!firstTimeCalled) {
  //     console.log("chatlist updated no: 14");
  //     setChatList([]);
  //     setChatCount(0);
  //     setChatListPage(0);
  //     getChatsList(chatType);
  //   } else {
  //     setFirstTimeCalled(false);
  //   }
  // }, [chatType]);

  useEffect(() => {
    if (firstTimeCalled && chatList.length !== 0) {
      setFirstTimeCalled(false);
    } else {
      if (chatType == "groups" && chatList.length > 0) {
        console.log("chatlist updated no: 124");
        setChatList(
          chatList.filter((singleChat) => {
            return singleChat.type == 1;
          })
        );
      } else {
        setChatList(fullChatList);
        // console.log("chatlist updated no: 14");
        // setChatList([]);
        // setChatCount(0);
        // setChatListPage(0);
        getChatsList(chatType, false);
      }
    }
  }, [chatType]);

  // socketEmit("get_message_detail", { message_id: "646ef0eb12aa488d1d697897" });

  ////////////////////////////////////////////////////////////////////////

  //////////////////////Load more Chats///////////////////////////////////
  const loadMoreChats = async () => {
    try {
      if (chatType == "all") {
        const result = await _getAllChats(chatListPage, 15);
        if (result.code == 200) {
          let tempChatList = chatList.concat(
            modifiedChatList(result.chat_list.chat_list)
          );
          const uniqueArray = tempChatList.reduce((accumulator, current) => {
            const isDuplicate = accumulator.find(
              (item) => item._id === current._id
            );
            if (!isDuplicate) {
              return [...accumulator, current];
            }
            return accumulator;
          }, []);
          // setChatList((prev) => {
          //   return prev.concat(modifiedChatList(result.chat_list.chat_list));
          // });
          console.log("chatlist updated no: 15");
          setChatList(uniqueArray);
          setFullChatList(uniqueArray);
          setChatCount(result.chat_list.chat_list_count);
          setChatListPage((prev) => prev + 1);
        } else {
          enqueueSnackbar(result.message, { variant: "error" });
        }
      } else if (chatType == "groups") {
        const result = await _getGroupChatList(chatListPage, 15);
        if (result.code == 200) {
          console.log("chatlist updated no: 16");
          setChatList((prev) => {
            return prev.concat(
              modifiedChatList(result.group_list.group_chat_list)
            );
          });
          setFullChatList((prev) => {
            return prev.concat(
              modifiedChatList(result.group_list.group_chat_list)
            );
          });
          setChatCount(result.group_list.group_chat_list_count);
        } else {
          enqueueSnackbar(result.message, { variant: "error" });
        }
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      console.log(error, "error catched");
    } finally {
      setChatListLoading(false);
    }
  };
  ////////////////////////////////////////////////////////////////////////
  //////////////////////Messages/////////////////////////////////////////
  const {
    setMessageList,
    messageList,
    messageCount,
    setMessageCount,
    messageListPageNo,
    setMessageListPageNo,
    chatData,
    setChatData,
    loadingMessageList,
    setLoadingMessageList,
  } = useAppContext();

  const getMessageList = async (chat) => {
    setLoadingMessageList(true);
    try {
      const result = await _getChatMessages(chat._id);
      if (result.code == 200) {
        setChatData(result.message.chat_data);
        setMessageList(result.message.message_list);
        setMessageCount(result.message.message_count);
        setMessageListPageNo((prev) => prev + 1);

        const res = await _seenMessages(chat._id);
        if (res.code == 200) {
          console.log("Calling seen message socket event");

          let receivers = chat.member_user;
          let receviverIds = receivers?.map((member) => {
            return member.user_id;
          });
          socketEmit("on_message_read", {
            chat_id: chat._id,
            receivers_id: receviverIds,
          });
          socketEmit("send_unread_count", {
            user_id: dispatch_get_user_profile().user_id,
          });
        } else {
          console.log("Failed to call seen message API: ", res.message);
        }
      } else if (
        result.message == "Cannot read properties of null (reading 'type')"
      ) {
        setCurrentChat();
        del_from_sessionStorage("currentChat");
        console.log("chatlist updated no: 17");
        setChatList((prev) =>
          prev.filter((prevChat) => prevChat._id !== chat._id)
        );
        setFullChatList((prev) =>
          prev.filter((prevChat) => prevChat._id !== chat._id)
        );
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      console.log(error, " error catched");
    } finally {
      setLoadingMessageList(false);
    }
  };
  useEffect(() => {
    if (messageList.length == 0) {
      currentChat && getMessageList(currentChat);
    }
  }, []);
  /////////////////////////////////////////////////////////////////////////////
  //////////////////////////////Load More Messages/////////////////////////////
  const loadMoreMessages = async () => {
    try {
      const result = await _getChatMessages(currentChat._id, messageListPageNo);
      if (result.code == 200) {
        setMessageList((prev) => {
          return prev.concat(result.message.message_list);
        });
        setMessageListPageNo((prev) => prev + 1);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      console.log(error, "error catched while loading more messages");
    }
  };
  ///////////////////////On Chat Click/////////////////////

  const onChatClick = async (chat) => {
    console.log(chat, "Clicked Chat");
    const unreadCount = chat.unread_count || 0;

    if (currentChat?._id == chat._id) {
      // shamroz - include id in path /chat/{id}
      if (id !== chat._id) {
        navigate(`/chats/${chat._id}`);
      }
      // -------------------------------------
      setChatListDrawerOpen(false);
      // Even if already on this chat, update unread count to 0
      setChatList((prev) => {
        return prev.map((cht) => {
          if (chat._id == cht._id) {
            return { ...cht, unread_count: 0 };
          } else {
            return { ...cht };
          }
        });
      });
      setBadge((prev) => {
        return { ...prev, chat: Math.max(prev.chat - unreadCount, 0) };
      });
      setCurrentChat({
        ...chat,
        unread_count: 0,
      });
      return;
    } else {
      // shamroz - include id in path /chat/{id}
      navigate(`/chats/${chat._id}`);
      // -------------------------------------

      let findedUser = chat?.member_user?.find((user) => {
        return user.user_id == chat?.creator_id;
      });
      console.log(findedUser);

      setMessageListPageNo(0);
      setMessageCount(0);
      // setMessageList([]);
      // setChatData();
      await getMessageList(chat);
      console.log("chatlist updated no: 18");
      setChatList((prev) => {
        return prev.map((cht) => {
          if (chat._id == cht._id) {
            return { ...cht, unread_count: 0 };
          } else {
            return { ...cht };
          }
        });
      });
      setChatListDrawerOpen(false);
      setCurrentChat({
        ...chat,
      });
      setBadge((prev) => {
        return { ...prev, chat: Math.max(prev.chat - unreadCount, 0) };
      });
    }
  };
  // shamroz - include id in path /chat/{id}
  const [urlChatLoading, setUrlChatLoading] = useState(false);
  // Sync URL chat ID with selected chat
  useEffect(() => {
    if (!id) {
      // No ID in URL — if a chat is already selected, reflect it in the URL
      if (currentChat?._id) {
        navigate(`/chats/${currentChat._id}`, { replace: true });
      }
      return;
    }
    // If the current chat already matches the URL ID, nothing to do
    if (currentChat?._id === id) return;
    const selectedChat = chatList.find((chat) => chat._id === id);
    if (selectedChat) {
      onChatClick(selectedChat);
      return;
    }
    // Chat not in the loaded list — fetch it directly by ID
    if (!urlChatLoading && chatList.length >= 0) {
      const fetchChatById = async () => {
        setUrlChatLoading(true);
        setLoadingMessageList(true);
        try {
          const result = await _getChatMessages(id);
          if (result.code === 200) {
            const chatData = result.message.chat_data;
            setChatData(chatData);
            setMessageList(result.message.message_list);
            setMessageCount(result.message.message_count);
            setMessageListPageNo(1);

            const modifiedChat = getModifiedChatItem(chatData);
            setCurrentChat(modifiedChat);

            setChatList((prev) => {
              const exists = prev.find((c) => c._id === id);
              if (!exists) {
                return [modifiedChat, ...prev];
              }
              return prev;
            });
            setFullChatList((prev) => {
              const exists = prev.find((c) => c._id === id);
              if (!exists) {
                return [modifiedChat, ...prev];
              }
              return prev;
            });

            const res = await _seenMessages(id);
            if (res.code === 200) {
              let receivers = chatData.member_user;
              let receiverIds = receivers?.map((member) => member.user_id);
              socketEmit("on_message_read", {
                chat_id: id,
                receivers_id: receiverIds,
              });
              socketEmit("send_unread_count", {
                user_id: dispatch_get_user_profile().user_id,
              });
            }
          } else {
            enqueueSnackbar(result.message || "Chat not found", {
              variant: "error",
            });
            navigate("/chats", { replace: true });
          }
        } catch (error) {
          console.log(error, "error fetching chat by URL ID");
          enqueueSnackbar("Something went wrong!", { variant: "error" });
          navigate("/chats", { replace: true });
        } finally {
          setLoadingMessageList(false);
          setUrlChatLoading(false);
        }
      };
      fetchChatById();
    }
  }, [id, chatList]);
  // -------------------------------------

  //////////////if the screen is small/////////////////////
  const [isMobile, setIsMobile] = useState(
    window.innerWidth > 768 ? false : true
  );

  function getNotificationData() {
    let totalUserUnread = 0;
    chatList.map((chat) => {
      if (chat?.unread_count !== 0) {
        totalUserUnread++;
      }
    });
    return totalUserUnread;
  }

  function onLastMassageView() {
    setCurrentChat({
      ...currentChat,
      unread_count: 0,
    });
  }

  useEffect(() => {
    // setIsOpenChatDialog(false);
    // if (isMobile) {
    //   setChatListDrawerOpen(true);
    // }
    window.addEventListener("resize", () => {
      if (window.innerWidth > 768) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
      return () => {
        removeEventListener("resize");
      };
    });
  }, []);
  /////////////////Clean Up////////////////////////////////////
  useEffect(() => {
    return () => {
      // setMessageListPageNo(0);
      // setChatListPage(0);
      // setMessageList([]);
      // setMessageCount(0);
      // setChatList([]);
      // setChatType("all");
      // setCurrentChat();
      // setChatCount(0);
      // del_from_local_storage("currentChat");
      // del_from_local_storage("chatType");
    };
  }, []);

  ////////////////////////////////////////////////////////////
  return (
    <Page
      title={currentChat ? capitalizeAllWords(currentChat?.label) : "All Chat"}
      height={"88.1vh"}
    >
      <Container maxWidth={false}>
        {!isOpenChatDialog && (
          <div className="row chat-container common-border">
            {!isMobile && (
              <div className="col-3 chat-users common-border hide-overflow">
                <div className="sidebar-container">
                  <Typography variant="h6" fontWeight={700}>
                    Messages ({getNotificationData()})
                  </Typography>
                  <IconButton className="icon-button-padding">
                    <MarkEmailReadIcon
                      fontSize="medium"
                      className="icon-color"
                    />
                  </IconButton>
                </div>

                <TabContext value={chatType}>
                  <TabList onChange={(e, val) => setChatType(val)}>
                    <Tab sx={{ width: "50%" }} label="All Chats" value="all" />
                    <Tab sx={{ width: "50%" }} label="Groups" value="groups" />
                  </TabList>
                </TabContext>
                <ChatListSidebar
                  chatType={chatType}
                  onChatClick={onChatClick}
                  setChatType={setChatType}
                  chatCount={chatCount}
                  chatList={chatList}
                  setChatList={setChatList}
                  chatListPage={chatListPage}
                  currentChat={currentChat}
                  setCurrentChat={setCurrentChat}
                  loadMoreChats={loadMoreChats}
                  setIsAddChatDrawerOpen={setIsAddChatDrawerOpen}
                />
              </div>
            )}
            {isMobile && (
              <ChatListDrawer
                isOpen={chatListDrawerOpen}
                onClose={() => setChatListDrawerOpen(false)}
              >
                <div className="mobile-sidebar">
                  <Typography variant="h6" fontWeight={700}>
                    Messages ({getNotificationData()})
                  </Typography>
                  <IconButton className="icon-button-padding">
                    <MarkEmailReadIcon
                      fontSize="medium"
                      className="icon-color"
                    />
                  </IconButton>
                </div>
                <TabContext value={chatType}>
                  <TabList onChange={(e, val) => setChatType(val)}>
                    <Tab sx={{ width: "50%" }} label="All Chats" value="all" />
                    <Tab sx={{ width: "50%" }} label="Groups" value="groups" />
                  </TabList>
                </TabContext>
                <div className="col-12 chat-users-hidden common-border">
                  <ChatListSidebar
                    chatType={chatType}
                    onChatClick={onChatClick}
                    setChatType={setChatType}
                    chatCount={chatCount}
                    chatList={chatList}
                    setChatList={setChatList}
                    chatListPage={chatListPage}
                    currentChat={currentChat}
                    setCurrentChat={setCurrentChat}
                    loadMoreChats={loadMoreChats}
                    setIsAddChatDrawerOpen={setIsAddChatDrawerOpen}
                  />
                </div>
              </ChatListDrawer>
            )}
            {currentChat && (
              <ShowSingleChat
                chatList={chatList}
                handleAddNewChat={handleAddNewChat}
                currentChat={currentChat}
                setCurrentChat={setCurrentChat}
                setChatListDrawerOpen={setChatListDrawerOpen}
                messageCount={messageCount}
                loadMoreMessages={loadMoreMessages}
                isMobile={isMobile}
                onLastMassageView={onLastMassageView}
              />
              // <div
              //   className={`${!isMobile ? "col-9 chat-messages" : "col-12 chat-messages-full"
              //     } common-border`}
              // >
              //   <div className="full-chat-container">
              //     <ChatHeader
              //       chatList={chatList}
              //       onChatClick={onChatClick}
              //       isMobile={isMobile}
              //       currentChat={currentChat}
              //       setCurrentChat={setCurrentChat}
              //       setChatListDrawerOpen={setChatListDrawerOpen}
              //     />
              //     <MessageContainer
              //       loadingMessageList={loadingMessageList}
              //       messageCount={messageCount}
              //       loadMoreMessages={loadMoreMessages}
              //       currentChat={currentChat}
              //     />
              //   </div>
              // </div>
            )}
            {!currentChat && (
              <div
                className={`${
                  !isMobile
                    ? "col-9 chat-messages"
                    : "col-12 chat-messages-full"
                } common-border`}
              >
                <div className="d-flex flex-column justify-content-center align-items-center height-full">
                  <Box className="circular-style" component="img" src={chat} />
                  {isMobile && chatList.length > 0 && !chatListLoading && (
                    <Button
                      variant="contained"
                      sx={{ width: "30%" }}
                      onClick={() => setChatListDrawerOpen(true)}
                    >
                      Go to Chats!
                    </Button>
                  )}
                  {isMobile && chatList.length == 0 && !chatListLoading && (
                    <Button
                      variant="contained"
                      sx={{ width: "30%" }}
                      onClick={() => setIsAddChatDrawerOpen(true)}
                    >
                      Create a Chat
                    </Button>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </Container>
      <AddChatDrawer
        open={isAddChatDrawerOpen}
        onClose={() => setIsAddChatDrawerOpen(false)}
        setMessageListPageNo={setMessageListPageNo}
        handleAddNewChat={handleAddNewChat}
        isLoading={addChatLoading}
      />
    </Page>
  );
}

export default Chats;
